import { AbstractControl } from '@angular/forms';

const NAME_PATTERN = `^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$`;
const NAME_REGEX = new RegExp(NAME_PATTERN);

export class NameValidator {
  static validate(form: AbstractControl) {
    const isValidName = NAME_REGEX.test(form.value);
    return isValidName ? null : { invalidName: true };
  }
}
